import { useEffect, useState } from 'react'

export function useOnScreen({ deps, initialValue = false, ref }) {
  const [isIntersecting, setIntersecting] = useState(initialValue)

  useEffect(() => {
    if (ref.current) {
      const observer = new IntersectionObserver(([entry]) => {
        setIntersecting(entry.isIntersecting)
      })

      observer.observe(ref.current)

      return function cleanup() {
        observer.disconnect()
      }
    }
  }, [deps])

  return isIntersecting
}
